"use client";

import { createContext, useContext } from "react";
import { useKindeBrowserClient } from "@kinde-oss/kinde-auth-nextjs";
import { useFetchStateFromKinde } from "@/lib/persistState";

const KindeSessionContext = createContext(null);

export function useKindeSession() {
  const session = useContext(KindeSessionContext);
  if (!session) {
    throw new Error("useKindeSession must be used within KindeWrapper");
  }
  return session;
}

const KindeWrapper = ({ children }) => {
  // The SDK fetches /api/auth/setup when this hook mounts. Resolve it once and
  // share the result instead of mounting another SDK hook in every consumer.
  const session = useKindeBrowserClient();
  useFetchStateFromKinde(session);

  return (
    <KindeSessionContext.Provider value={session}>
      {children}
    </KindeSessionContext.Provider>
  );
};

export default KindeWrapper;
